export function operatorSaveErrorMessage(error: unknown): string {
  const data = (
    error as {
      response?: { data?: { detail?: unknown; fields?: unknown } };
    } | null
  )?.response?.data;
  if (Array.isArray(data?.fields)) {
    const messages = data.fields.flatMap((field: unknown) => {
      const message = (field as { message?: unknown } | null)?.message;
      return typeof message === 'string' && message.trim() ? [message] : [];
    });
    if (messages.length > 0) return messages.join(' ');
  }
  if (typeof data?.detail === 'string' && data.detail.trim()) return data.detail;
  return 'The order could not be saved. Your changes are still on this screen. Please try again.';
}
